import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;

  overflow-y: hidden;

  .sidebarContainer {
    width: 6vw;
    height: 100vh;
  }

  .childrenContainer {
    height: 100vh;

    max-width: 95vw;
    width: 95vw;

    overflow-y: auto;
  }

  .tableWrapper {
    display: flex;
    flex-direction: column;
    padding: 2rem 3rem;
    /* overflow-x: hidden; */

    height: 100%;

    .table-container {
      max-width: 100%;
      max-height: 100%;
      overflow-x: scroll;
    }

    .dashboardTable {
      margin-top: 2rem;
      border-collapse: collapse;
      margin-bottom: auto;
      width: 100%;
      overflow-x: scroll;

      thead {
        tr {
          padding-bottom: 1.5rem;
          border-bottom: 1px solid var(--grey-300);
          width: 100%;

          th {
            button {
              justify-content: flex-start;
              align-items: center;
              display: flex;
              width: 20rem !important;
              background: none;
              border: none;
              color: var(--grey-100);
              font-family: Inter;
              font-style: normal;
              font-weight: normal;
              font-size: 0.875rem;
              line-height: 0.875rem;
            }

            text-align: start;
            padding-bottom: 1.5rem;

            img {
              margin-left: 0.5rem;
              margin-bottom: 0.125rem;

              @keyframes rotate-keyframes {
                from {
                  transform: rotate(0deg);
                }
              }
            }
          }
        }
      }

      tbody {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        
        tr {
          border-bottom: 1px solid var(--black-200);
          border-top: 1px solid var(--black-200);

          td {
            height: 1rem;
            font-size: 1rem;
            line-height: 1rem;
            padding-top: 1.25rem;
            padding-bottom: 1.25rem;
            padding-right: 1rem;
            color: var(--white);
          }

          .ellipsed {
            max-width: 250px;
          }

          .ellipsedSm {
            max-width: 150px;
          }

          .ellipsed,
          .ellipsedSm {
            white-space: nowrap;
            overflow: hidden;
            padding-right: 1.2rem;
            text-overflow: ellipsis;
          }

          &:last-of-type {
            border-bottom: none;
          }
          .flex {
            display: flex;
            flex-direction: row;
            padding-left: 0 20px;
            width: 90px;
            button {
              font-weight: 500;
            }
            button:last-of-type {
              margin-left: 0.5rem;
            }
          }
        }
      }
    }
  }

  .active {
    font-size: 0.875rem;
    line-height: 0.875rem;
    height: 2rem;
    width: 5.625rem;
    align-items: center;
    justify-content: center;
    color: var(--green);

    background: rgba(71, 212, 68, 0.1);

    border-radius: 6.25rem;
  }
  .disabled {
    font-size: 0.875rem;
    line-height: 0.875rem;
    align-items: center;
    justify-content: center;
    background: rgba(184, 184, 184, 0.1);
    height: 2rem;
    width: 6.1875rem;
    color: var(--grey-100);

    border-radius: 6.25rem;
  }
  .arrowUp {
    transform: rotate(180deg);
  }
`;
